export default __webpack_public_path__ + "static/media/personal-loan-chart-1.08f7ad2c.svg";